const Content = {
    'contact': {
        'title': 'Contact',
        'email': 'inquiry@nrgmr.com',
        'phone': '+1 (323) 406-6200',
        'linkedin': 'https://www.linkedin.com/company/national-research-group-a-stagwell-company',
        'privacy_title': 'Privacy Policies',
        'privacy_href': '/privacy',
        'ccpa_title': 'Do Not Sell My Personal Information',
        'ccpa_href': '/privacy#section8e'
    },
    'careers': {
        'title': 'Careers',
        'href': '/people#careers',
        'openings': 'Openings'
    },
	'si': {
        'title': 'Singapore',
        'address_1': '18 Cross Street, #02-101',
        'address_2': 'Singapore 048423',
		'address_3': 'Singapore',
    },
    'london': {
        'title': 'London',
        'address_1': '100 Leman Street (3rd Floor)',
        'address_2': 'London, E1 8EU',
        'address_3': 'United Kingdom'
    },
    'la': {
        'title': 'Los Angeles',
        'address_1': '12101 W. Bluff Creek Drive',
        'address_2': 'Los Angeles, CA 90094',
        'address_3': 'United States'

    },
    'ny': {
        'title': 'New York',
        'address_1': 'One World Trade Center (63rd Floor)',
        'address_2': '285 Fulton Street',
        'address_3': 'New York, NY 10007',
        'address_4': 'United States'
    },
    'footnote': '2022 National Research Group, Inc. or its affiliated companies, all rights reserved.'
};

export { Content };
